function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M11.7253 0H4.27556C1.57333 0 0 1.58222 0 4.29333V13.4756C0 16.2311 1.57333 17.7778 4.27556 17.7778H11.7253C14.4711 17.7778 16 16.2311 16 13.4756V4.29333C16 1.58222 14.4711 0 11.7253 0Z",
  fill: "#C4C4C4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "white",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.51552 4.1333V4.14219C4.13241 4.14219 3.82218 4.4533 3.82218 4.83552C3.82218 5.21775 4.13241 5.52886 4.51552 5.52886H7.17241C7.55552 5.52886 7.86663 5.21775 7.86663 4.82575C7.86663 4.44441 7.55552 4.1333 7.17241 4.1333H4.51552ZM11.4844 9.54668H4.51552C4.13241 9.54668 3.82218 9.23557 3.82218 8.85335C3.82218 8.47113 4.13241 8.15913 4.51552 8.15913H11.4844C11.8666 8.15913 12.1777 8.47113 12.1777 8.85335C12.1777 9.23557 11.8666 9.54668 11.4844 9.54668ZM11.4844 13.6088H4.51552C4.24885 13.6444 3.99108 13.511 3.84885 13.2888C3.70663 13.0577 3.70663 12.7644 3.84885 12.5421C3.99108 12.311 4.24885 12.1866 4.51552 12.2133H11.4844C11.8391 12.2488 12.1066 12.551 12.1066 12.9155C12.1066 13.2701 11.8391 13.5732 11.4844 13.6088Z",
  fill: "#C4C4C4"
});

function SvgDocumentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.7692c6d4.svg";
export { ForwardRef as ReactComponent };